<template>
    <Header></Header>
    <div class="container _intro sub_page">
        <section class="sub_page_tit">
            <div class="deco_wrap">
                <i class="deco_01 _xsmall spin3"><img src="img/b_icon_03.png" /></i>
                <i class="deco_02 _small blink_zoom1"><img src="img/b_icon_01.png" /></i>
                <i class="deco_03 _xsmall spin_blink2"><img src="img/b_icon_03.png" /></i>
                <i class="deco_04 _small blink_blink3"><img src="img/b_icon_01.png" /></i>
                <i class="deco_character"><img src="img/intro_icon.png" /></i>
            </div>
            <div class="banner_wrap wrap_1120">
                <h2>소개</h2>
            </div>
            <div class="sub_menu_tab wrap_1120" ref="header">
                <button class="only_768" @click="subMenuTab" :class="{ active: state.subMenuOpen }">{{ state.subMenuName }}</button>
                <ul :class="{ active: state.subMenuOpen }">
                    <li @click="changeTab(1)" :class="[state.tab === 1 ? 'active' : '']">
                        <a href="javascript:void(0)">반성매매 시민참여 플랫폼</a>
                    </li>
                    <li @click="changeTab(2)" :class="[state.tab === 2 ? 'active' : '']"><a href="javascript:void(0)">다시함께상담센터</a></li>
                    <li @click="changeTab(3)" :class="[state.tab === 3 ? 'active' : '']"><a href="javascript:void(0)">자주 묻는 질문</a></li>
                </ul>
            </div>
        </section>
        <section class="sub_page_con wrap_1120 _activity">
            <div class="bread_crumbs">
                <router-link to="/" class="icon_wrap"><img src="img/home_icon.png" alt="홈" /></router-link>
                <!-- <span class="icon_wrap"><img src="img/part_icon.png" alt="소개" /></span>
                <a href="">소개</a> -->
                <span class="icon_wrap"><img src="img/part_icon.png" alt="자주묻는 질문(FAQ)" /></span>
                <router-link :to="{ path: '/intro', query: { type: 3 } }">자주묻는 질문(FAQ)</router-link>
                <span class="icon_wrap"><img src="img/part_icon.png" alt="글쓰기" /></span>
                <!-- <a href="javascript:void(0)">글쓰기</a> -->
                <span class="faq_list_title">글쓰기</span>
            </div>
            <div class="sub_page_con_view con_write">
                <ul class="">
                    <li>
                        <label for="title" class="">제목</label>
                        <input id="title" type="text" placeholder="제목을 입력하세요" v-model="form_state.title" />
                    </li>
                    <li>
                        <span class="form_li_tit">내용</span>
                        <textarea id="editor1" name="editor1"></textarea>
                    </li>
                    <li class="file_wrap">
                        <span class="form_li_tit">첨부</span>
                        <label for="area_file">
                            <input id="area_file" type="file" placeholder="" accept="image/*" multiple @change="handleFiles" />
                            <div class="file_box_wrap">‘파일첨부’ 버튼을 클릭하여 첨부해주세요</div>
                            <span class="blue_btn" style="display: flex; justify-content: center; align-items: center">파일첨부</span>
                            <p class="p_info">200M 이하 JPG, PNG 파일을 첨부해주세요.</p>
                        </label>
                        <div class="file_list">
                            <div class="file" v-for="(item, idx) in form_state.file" :key="idx">
                                <span class="file_name" @click="downloadFile(item.file, item.fileImgRealName)">{{ item.fileImgRealName }}</span>
                                <button class="file_del icon_wrap" @click="fileRemove(item.fileIdx)">
                                    <img src="img/close_02.png" alt="" />
                                </button>
                            </div>

                            <div class="file" v-for="(item, index) in state.file" :key="index">
                                <span class="file_name">{{ item.name }}</span>
                                <button class="file_del icon_wrap" @click="removeNewFile(index)">
                                    <img src="img/close_02.png" alt="" />
                                </button>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="btn_wrap _default">
                <button class="common_btn _gray w_130" @click="router.go(-1)">취소</button>
                <button class="common_btn w_130" @click="state.isShowPreview = true" v-if="!state.isMobile">미리보기</button>
                <button class="common_btn w_130" @click="save">작성완료</button>
            </div>
        </section>
    </div>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>

    <ModalPreview
        v-if="state.isShowPreview"
        :header="header.innerHTML"
        :title="form_state.title"
        :content="form_state.content"
        @close="state.isShowPreview = false"
    ></ModalPreview>
    <Footer></Footer>
</template>

<script lang="ts" config>
    import {
        Header,
        Footer,
        reactive,
        globalStore,
        onMounted,
        router,
        watch,
        faqList,
        userStore,
        useRoute,
        ModalDefault,
        ModalPreview,
        onBeforeMount,
        CkEditorManager,
        types,
        apiService,
        getMessageByCode,
        onBeforeUnmount,
        ref,
    } from "@/BaseComponent";

    export default {
        components: { Header, Footer, FaqList: faqList, ModalDefault, ModalPreview },
        setup() {
            const route = useRoute();
            const user = userStore();
            const global = globalStore();
            const state = reactive({
                tab: 0 as number,

                idx: 0 as number,
                isShowModal: false as boolean,
                isMobile: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                isShowPreview: false as boolean,

                isAuth: false,
                file: [] as Array<File>,

                subMenuOpen: false as boolean,
                subMenuName: "반성매매 시민참여 플랫폼" as string,
            });

            const form_state = reactive({
                title: "" as string,
                content: "" as string,

                file: [] as Array<types.ResFaqFileVOForApi>,
            });

            let editorManager: CkEditorManager | null = null;

            onBeforeMount(() => {
                if (!(user.isLogin() && user.userInfo.gubun === 1)) {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "권한이 없습니다.";
                    state.isShowModal = true;
                }
            });

            onMounted(async () => {
                if (global.introTab > 0) changeTab(global.introTab);
                else changeTab(1);

                if (route.query.tab) {
                    const number = Number(route.query.tab);
                    changeTab(number);
                }

                state.isAuth = false;
                const idx = Number(route.params.id);
                if (route.params.id) {
                    if (idx && typeof idx === "number" && !isNaN(idx)) {
                        state.idx = idx;

                        if (user.isLogin()) {
                            editorManager = new CkEditorManager("editor1", form_state, "faq");
                            await editorManager.initEditor();

                            await getDetail();
                        } else {
                            state.modalTab = -1;
                            state.modalTitle = "안내";
                            state.modalContent = "접근 권한이 없습니다.";
                            state.isShowModal = true;
                        }
                    } else {
                        router.back();
                    }
                } else {
                    editorManager = new CkEditorManager("editor1", form_state, "faq");
                    editorManager.initEditor();
                }
            });

            onBeforeUnmount(() => {
                editorManager?.destroy();
            });

            watch(
                () => route.params.id,
                () => {
                    const idx = Number(route.params.id);
                    state.idx = idx;
                    getDetail();
                },
            );

            const header = ref();

            const getDetail = async () => {
                const res = await apiService.faq.detail(state.idx);

                if (res.returnCode === 0) {
                    form_state.title = res.data.title;
                    form_state.content = res.data.content;
                    form_state.file = res.data.fileList;

                    await editorManager?.setDataInfo(form_state.content);
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const fileRemove = async (idxFile: number) => {
                const res = await apiService.faq.removeForFile(state.idx, idxFile);
                if (res.returnCode === 0) {
                    const index = form_state.file.findIndex((item) => item.fileIdx === idxFile);
                    if (index !== -1) {
                        form_state.file.splice(index, 1);
                    }
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const downloadFile = async (fileUrl: string, fileName: string) => {
                const res = await fetch(fileUrl);
                const blob = await res.blob();
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                URL.revokeObjectURL(link.href);
            };

            const closeModal = () => {
                state.isShowModal = false;

                if (state.idx > 0 && state.modalTab === -1) router.replace({ name: "FaqView", params: { id: state.idx } });
                else if (state.modalTab !== 8) router.replace("/intro");
            };

            const callBackModal = async (param: any) => {
                state.isShowModal = false;
            };

            const handleFiles = (e: any) => {
                const target = e.target as HTMLInputElement;
                if (!target.files) return;

                const files: File[] = Array.from(target.files);

                const isFiles = files.filter((file) => !file.type.startsWith("image/"));

                if (isFiles.length > 0) {
                    state.modalTab = 8;
                    state.modalTitle = "알림";
                    state.modalContent = "이미지 파일만 업로드할 수 있습니다.";
                    state.isShowModal = true;

                    target.value = "";
                    return;
                }

                state.file = files;
                target.value = "";
            };

            // 새 파일 삭제
            const removeNewFile = (index: number) => {
                state.file.splice(index, 1);
            };

            const changeTab = (tab: number) => {
                state.tab = tab;
                global.setIntroTab(state.tab);
                if (state.tab !== 3) router.replace("/intro");
                state.subMenuOpen = false;
                switch (tab) {
                    case 1:
                        state.subMenuName = "반성매매 시민참여 플랫폼";
                        break;
                    case 2:
                        state.subMenuName = "다시함께상담센터";
                        break;
                    case 3:
                        state.subMenuName = "자주 묻는 질문";
                        break;
                }
            };

            const subMenuTab = () => {
                if (window.innerWidth <= 768) {
                    state.subMenuOpen = !state.subMenuOpen;
                }
            };

            const save = async () => {
                form_state.content = (await editorManager?.getData()) + "";
                if (!(form_state.title && form_state.content)) {
                    state.modalTab = 7;
                    state.modalTitle = "알림";
                    state.modalContent = "제목과 내용을 입력해주세요.";
                    state.isShowModal = true;
                } else {
                    if (!(state.idx > 0)) {
                        const param: types.ReqFaq = {
                            title: form_state.title,
                            content: form_state.content,
                            file: state.file,
                        };
                        const res = await apiService.faq.add(param);
                        if (res.returnCode === 0) {
                            state.modalTab = -1;
                            state.modalTitle = "안내";
                            state.modalContent = "저장이 완료되었습니다.";
                            state.isShowModal = true;
                        } else if (res.returnCode === 11) {
                        } else {
                            state.modalTab = -1;
                            state.modalTitle = "예외 발생";
                            state.modalContent = getMessageByCode(res.returnCode);
                            state.isShowModal = true;
                        }
                    } else {
                        const param: types.ReqFaqForModify = {
                            idx: state.idx,
                            title: form_state.title,
                            content: form_state.content,
                            file: state.file,
                        };

                        if (state.file && state.file.length > 0) {
                            param.file = state.file;
                        }
                        const res = await apiService.faq.modify(param);
                        if (res.returnCode === 0) {
                            state.modalTab = -1;
                            state.modalTitle = "안내";
                            state.modalContent = "저장이 완료되었습니다.";
                            state.isShowModal = true;
                        } else if (res.returnCode === 11) {
                        } else {
                            state.modalTab = -1;
                            state.modalTitle = "예외 발생";
                            state.modalContent = getMessageByCode(res.returnCode);
                            state.isShowModal = true;
                        }
                    }
                }
            };

            return {
                state,
                changeTab,
                subMenuTab,
                form_state,
                fileRemove,
                downloadFile,
                closeModal,
                callBackModal,
                router,
                removeNewFile,
                save,
                handleFiles,
                header,
            };
        },
    };
</script>
<style scoped>
    .faq_list_title {
        color: #6d6d6d;
        font-size: 14px;
        font-weight: 500;
    }
</style>
